import {Injectable} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';
import {SubscriptionsService} from './subscriptions.service';
import * as globals from '../settings';
import {LotteriesService} from '../lotteries.service';
import {Router, NavigationEnd} from '@angular/router';
import {filter, map} from 'rxjs/operators';

@Injectable()
export class LanguageService {
    language: string;
    languageList: any;
    defaultLanguage: any;
    selectedLanguage: any;
    countryCode: string;

    constructor(private translate: TranslateService,
                private subscriptionsService: SubscriptionsService,
                private lotteryService: LotteriesService,
                private router: Router) {
        if (!localStorage.getItem('pageLanguage')) {
            this.setLangFromUrl();
        }
    }

    public makeLanguagesGreatAgain(type, countryCode?) {
        if (localStorage.getItem('pageLanguage')) {
            this.setLanguage(this.setLanguage(localStorage.getItem('pageLanguage')));
            this.selectedLanguage = localStorage.getItem('pageLanguage');
        } else {
            if (type === 'playerData') {
                this.setLanguage(countryCode);
                this.selectedLanguage = countryCode;
            } else if (type === 'countryOnly') {
                this.countryCode = countryCode;
                this.lotteryService.postData(globals.appDomain + '/PaymentsLanguages/getAvailable/getAvailableLanguages.json',
                    'countryCode=' + this.countryCode)
                    .subscribe(
                        result => {
                            this.languageList = result.message.languages;
                            this.defaultLanguage = this.languageList.filter(lang => lang.IsDefault === 1)[0].LanguageCode;
                            this.selectedLanguage = this.defaultLanguage.toLowerCase();
                            this.setLanguage(this.defaultLanguage);
                        }
                    );
            }
        }
        this.router.events.pipe(
            filter((event) => event instanceof NavigationEnd), map((event: any) => event.url),)
            .subscribe((event) => {
                if (event.indexOf('/en') > -1) {
                    if (this.translate.currentLang !== 'en') {
                        this.setLanguage('en');
                    }
                } else if (event.indexOf('/vi') > -1) {
                  if (this.translate.currentLang !== 'vi') {
                    this.setLanguage('vi');
                  }
                } else if (event.indexOf('/id') > -1) {
                  if (this.translate.currentLang !== 'id') {
                    this.setLanguage('id');
                  }
                } else if (event.indexOf('/de') > -1) {
                    if (this.translate.currentLang !== 'de') {
                        this.setLanguage('de');
                    }
                }
            });
    }


    public setLanguage(LanguageID) {
        if (LanguageID !== undefined) {
            const lang = LanguageID.toLowerCase();
            this.translate.use(lang);
            this.language = lang;
            localStorage.setItem('pageLanguage', lang);
            this.languageEmit(this.language);
        }

    }

    public languageEmit(lang) {
        this.subscriptionsService.emitLanguage(lang);
    }

    public setLangFromUrl() {
        const url = window.location.href.split('/');
        if (url[3] && (
          url[3] === 'en'
          || url[3] === 'de'
          || url[3] === 'vi'
          || url[3] === 'id'
        )) {
            this.setLanguage(url[3]);
        } else if (url[3]) {
            this.setLanguage('en');
        }
    }
}
